export const IMAGE_LOAD_TIMEOUT_MS = 15 * 60 * 1000;

export const IMAGE_LOAD_ERROR_MSG = 'Erro ao baixar imagem.';
export const IMAGE_LOAD_ERROR_FIX_MSG =
  'Erro ao baixar imagem. Arraste outra foto para substituir.';

const waitStartedAt = {};

export const startImageLoadWait = (id, now = Date.now()) => {
  if (id == null) return IMAGE_LOAD_TIMEOUT_MS;
  if (waitStartedAt[id] == null) {
    waitStartedAt[id] = now;
  }
  return Math.max(0, IMAGE_LOAD_TIMEOUT_MS - (now - waitStartedAt[id]));
};

export const hasImageLoadTimedOut = (id, now = Date.now()) => {
  const started = waitStartedAt[id];
  if (started == null) return false;
  return now - started >= IMAGE_LOAD_TIMEOUT_MS;
};

export const clearImageLoadWait = id => {
  if (id == null) return;
  delete waitStartedAt[id];
};

export const resetImageLoadWaits = () => {
  Object.keys(waitStartedAt).forEach(key => {
    delete waitStartedAt[key];
  });
};
